var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAcctivity = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "m13.313 9-.591.204.145.421h.445zm-1.876-5.437.591-.204a.625.625 0 0 0-1.16-.052zM6.564 14.438l-.591.203a.625.625 0 0 0 1.16.052zM4.688 9l.59-.204-.145-.421h-.445zM16.5 9v-.625h-3.187v1.25H16.5zm-3.187 0 .59-.204-1.875-5.437-.59.204-.591.203 1.875 5.438zm-1.876-5.437-.57-.256-4.875 10.875.57.255.57.256 4.876-10.875zM6.564 14.438l.59-.204-1.875-5.438-.59.204-.591.204 1.875 5.437zM4.688 9v-.625H1.5v1.25h3.188z" }) }))); };
export default SvgAcctivity;
